import './calendar-loading-cover.css'

const CalendarLoadingCover = () => {
    return (
        <div className='calendar-loading-cover'></div>
    )
}
export default CalendarLoadingCover;